import { useEffect, useState } from 'react';

enum AGENT_TOOLBAR_STATES {
  CONTAINER = 'user-toolbar-container',
  EXPANDED = 'is-expanded',
}

type UseAgentToolbarObserverReturn = {
  agentToolbarExists: boolean;
  agentToolbarExpanded: boolean;
  agentToolbarHeight: number;
};

export const useAgentToolbarObserver = (): UseAgentToolbarObserverReturn => {
  const [agentToolbarExists, setAgentToolbarExists] = useState(false);
  const [isAgentToolbarExpanded, setIsAgentToolbarExpanded] = useState(false);
  const [agentToolbarHeight, setAgentToolbarHeight] = useState(0);
  useEffect(() => {
    const agentToolbarContainer = document.querySelector(`.${AGENT_TOOLBAR_STATES.CONTAINER}`);
    const agentToolbarOpen = document.querySelector(`.${AGENT_TOOLBAR_STATES.EXPANDED}`);

    if (agentToolbarContainer) {
      setAgentToolbarExists(true);
    } else {
      setAgentToolbarExists(false);
    }

    if (agentToolbarContainer) {
      if (agentToolbarOpen) {
        setIsAgentToolbarExpanded(true);
        setAgentToolbarHeight(42);
      } else {
        setIsAgentToolbarExpanded(false);
        setAgentToolbarHeight(0);
      }
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if ((mutation.target as HTMLElement).classList.contains(AGENT_TOOLBAR_STATES.EXPANDED)) {
          setIsAgentToolbarExpanded(true);
          setAgentToolbarHeight(42);
        } else {
          setIsAgentToolbarExpanded(false);
          setAgentToolbarHeight(0);
        }
      });
    });

    if (agentToolbarContainer) {
      observer.observe(agentToolbarContainer, {
        attributes: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    agentToolbarExists,
    agentToolbarExpanded: isAgentToolbarExpanded,
    agentToolbarHeight,
  };
};
